<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-refresh`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M29 20a1 1 0 01-1-1v-2a1 1 0 011-1h6.49c-2.53-3.627-6.732-6-11.49-6-7.732 0-14 6.268-14 14s6.268 14 14 14c6.342 0 11.699-4.217 13.42-10h4.134C39.734 36.017 32.566 42 24 42c-9.941 0-18-8.059-18-18S14.059 6 24 6c5.655 0 10.701 2.608 14.001 6.687L38 7a1 1 0 011-1h2a1 1 0 011 1v11a2 2 0 01-1.85 1.994L40 20H29z"/></svg>
</template>
<script>

export default {
  name: 'IconRefresh',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
